import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './index.css';

function Footer({ isPromo }) {
  const { t } = useTranslation();

  return (
    <footer
      className={`footer ${isPromo ? 'footer--promo' : ''}`}
      style={isPromo ? {} : { backgroundColor: '#eff7ff', height: '400px' }}
    >
      {isPromo ? (
        <div className="footer-promo-content">
          <div className="footer-promo-top">
            <div className="footer-promo-brand">
              <img
                src="/image/ff-promo/家庭友好企业Logo.png"
                alt={t('footer.promo.brandName')}
                className="footer-promo-logo"
              />
              <div className="footer-promo-brand-text">
                <span className="footer-promo-brand-name">{t('footer.promo.brandName')}</span>
                <span className="footer-promo-brand-en">{t('footer.promo.brandEn')}</span>
              </div>
            </div>
            <span className="footer-promo-slogan">{t('footer.promo.slogan')}</span>
          </div>
          <div className="footer-promo-divider" />
          <div className="footer-promo-bottom">
            <span className="footer-promo-copyright">© 2026 All rights reserved.</span>
            <span className="footer-promo-org">{t('footer.promo.org')}</span>
          </div>
        </div>
      ) : (
        <>
          <div className="footer-cloud-layer">
            <div
              className="footer-cloud-layer-compressed"
              style={{ backgroundImage: 'url(/image/页脚云-压缩.png)' }}
            />
          </div>
          <div className="footer-content">
            <div className="footer-social">
              <span className="footer-social-title">{t('footer.followUs')}</span>
              <a
                href="https://www.facebook.com/profile.php?id=61587236318364"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label={t('footer.facebookAria')}
              >
                <img
                  src="/image/Facebook.png"
                  alt=""
                  className="footer-social-icon footer-social-icon-default"
                />
                <img
                  src="/image/Facebook-hover.png"
                  alt=""
                  className="footer-social-icon footer-social-icon-hover"
                />
              </a>
              <a
                href="https://www.youtube.com/@GenovationFoundation"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label={t('footer.youtubeAria')}
              >
                <img
                  src="/image/Youtube.png"
                  alt=""
                  className="footer-social-icon footer-social-icon-default"
                />
                <img
                  src="/image/Youtube-hover.png"
                  alt=""
                  className="footer-social-icon footer-social-icon-hover"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/genovationfoudation/about/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label={t('footer.youtubeAria')}
              >
                <img
                  src="/image/Linkedin.png"
                  alt=""
                  className="footer-social-icon footer-social-icon-default"
                />
                <img
                  src="/image/Linkedin-hover.png"
                  alt=""
                  className="footer-social-icon footer-social-icon-hover"
                />
              </a>
            </div>
            <div className="footer-bottom">
              <div className="footer-left">
                <span>{t('footer.copyright')}</span>
              </div>
              <div className="footer-right">
                <Link to="/privacy-policy" className="footer-link">
                  {t('footer.privacy')}
                </Link>
                <Link to="/terms-of-service" className="footer-link">
                  {t('footer.terms')}
                </Link>
              </div>
            </div>
          </div>
        </>
      )}
    </footer>
  );
}

export default Footer;
